export default __webpack_public_path__ + "static/women-6e95bfe2cea4475c2c5abfd037fefd6d.png";